import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=8bd7a3d4"
import script from "./JobCard.vue?vue&type=script&lang=js"
export * from "./JobCard.vue?vue&type=script&lang=js"
import style0 from "./JobCard.vue?vue&type=style&index=0&id=8bd7a3d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports